import styled from "@emotion/styled";
import { DisplayText, ThemeText } from "components/lib";
import joinMember from "assets/joinMemberBgEn.png";
import JoinMembership from "assets/Join Membership.png";
import freeToJoin_nocashbak_nodiscount_no_prepaid_card from "assets/freeToJoin_nocashbak_nodiscount_no_prepaid_card.png";
import notfreeToJoin from "assets/not_free_join_as_member_loyalty_bk.png";

import { JoinBackground } from "./page-recharge";
import { JoinMemberMode } from "types/joinAsMemberMode";
export const PageBannerEn = (props: {
  count: number;
  backNum: number;
  restaurantName: string;
  hasPrePay: boolean;
  isVisible: Boolean;
  joinAsMemberMode: JoinMemberMode;
  afterLoad?: () => void;
}) => {
  const countNum = 100 - props.count;
  const countNumLen = `${countNum}`.length;
  const backNumLen = `${props.backNum}`.length;
  const hasCount = countNum !== 0;
  const styleObjs = {
    imgStyleObj: {
      width: "29.5rem",
      height: "7.4rem",
      margin: "1rem auto 0 auto",
      display: "block",
      objectfit: "cover",
    },
    hundredStyle: {
      letterSpacing: "-0.3rem",
      bottom: "4.2rem",
      fontSize: "5rem",
      left: 0,
    },
    oneLenStyle: {
      left: "2rem",
    },
  };

  const getBannerNumber = () => {
    if (countNumLen === 1) {
      return styleObjs.oneLenStyle;
    } else if (countNumLen === 3) {
      return styleObjs.hundredStyle;
    } else {
      return {};
    }
  };

  const handleOnCload = () => {
    if (props.afterLoad) {
      props.afterLoad();
    }
  };

  if (props.joinAsMemberMode !== JoinMemberMode.free_join) {
    return (
      <div>
        <BannerWrapper style={{ display: props.isVisible ? "block" : "none" }}>
          <ThemeText style={{ fontWeight: 600, marginTop: "3rem" }}>
            Welcome to join {props.restaurantName}
          </ThemeText>
          <>
            <JoinBackground
              style={{ background: "none", height: "auto" }}
            >
              <DisplayText>
                <img
                  src={notfreeToJoin}
                  style={{ width: "100%" }}
                  onLoad={handleOnCload}
                  loading="eager"
                  alt="banner"
                ></img>
              </DisplayText>
            </JoinBackground>
          </>
        </BannerWrapper>
      </div>
    );
  }

  if (!hasCount && !!!props.backNum && !!!props.hasPrePay) {
    return (
      <div>
        <BannerWrapper style={{ display: props.isVisible ? "block" : "none" }}>
          <ThemeText style={{ fontWeight: 600, marginTop: "3rem" }}>
            Welcome to join {props.restaurantName}
          </ThemeText>
          <>
            <JoinBackground
              style={{ backgroundColor: "transparent", height: "auto" }}
            >
              <DisplayText>
                <img
                  src={freeToJoin_nocashbak_nodiscount_no_prepaid_card}
                  style={{ width: "100%" }}
                  onLoad={handleOnCload}
                  loading="eager"
                  alt="banner"
                ></img>
              </DisplayText>
            </JoinBackground>
          </>

          <BannerCount
            fontWieght={700}
            style={{ fontSize: "1.75rem", marginTop: "0.5rem" }}
          >
            Looking forward to more member benefits
          </BannerCount>
        </BannerWrapper>
      </div>
    );
  } else {
    return (
      <div>
        <BannerWrapper style={{ display: props.isVisible ? "block" : "none" }}>
          <ThemeText style={{ fontWeight: 600, marginTop: "3rem" }}>
            Welcome to join {props.restaurantName}
          </ThemeText>
          {hasCount && !!props.backNum && (
            <>
              <img
                style={styleObjs.imgStyleObj}
                src={joinMember}
                onLoad={handleOnCload}
                loading="eager"
                alt="banner en"
              />
              <BannerCount
                fontSize={backNumLen === 2 ? 2.3 : 2.5}
                fontWieght={700}
              >
                {props.backNum}% Cashback For Every Order
              </BannerCount>
              <BannerNumber style={getBannerNumber()}>{countNum}%</BannerNumber>
            </>
          )}
          {/* 缺了收单折扣或返现 */}
          {(!hasCount || !props.backNum) && (
            <>
              <JoinBackground>
                <DisplayText>
                  <img
                    src={JoinMembership}
                    style={{ width: "28rem" }}
                    onLoad={handleOnCload}
                    loading="eager"
                    alt="banner"
                  ></img>
                </DisplayText>
              </JoinBackground>
            </>
          )}
          {/* 仅有返现 */}
          {!hasCount && !!props.backNum && (
            <BannerCount
              fontSize={backNumLen === 2 ? 2.3 : 2.5}
              fontWieght={700}
            >
              {props.backNum}% Cashback For Every Order
            </BannerCount>
          )}
          {/* 仅有折扣 */}
          {hasCount && !props.backNum && (
            <BannerCount
              fontSize={countNumLen === 2 ? 2.3 : 2.5}
              fontWieght={700}
              style={{ wordSpacing: "0.3rem" }}
            >
              {countNum}% OFF On The First Order
            </BannerCount>
          )}
        </BannerWrapper>
      </div>
    );
  }
};

const BannerWrapper = styled.div`
  position: relative;
  width: 29.5rem;
  margin: 0 auto;
`;

const BannerCount = styled(ThemeText)`
  width: 29.5rem;
  height: 3.4rem;
  line-height: 3.4rem;
  font-family: Avenir Next Condensed, Avenir Next Condensed Back;
  margin-top: 9px;
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
`;

const BannerNumber = styled.span`
  position: absolute;
  font-family: Avenir Next Condensed, Avenir Next Condensed Back;
  font-weight: bold;
  font-size: 5.5rem;
  height: 7.6rem;
  color: #dc0047;
  bottom: 4.5rem;
  left: 0.6rem;
`;
